import { useEffect, useState } from "react";
import { format } from "date-fns";
import { de, enGB, es, fr } from "date-fns/locale";
import { LanguageSelector } from '@/components/LanguageSelector';
import { useLanguage } from '@/contexts/LanguageContext';

const dateLocales = { es, en: enGB, fr, de };

export const StatusBar = () => {
  const { language } = useLanguage();
  const [currentTime, setCurrentTime] = useState(new Date());

  useEffect(() => {
    const interval = setInterval(() => {
      setCurrentTime(new Date());
    }, 60000); // Actualizar cada minuto
    
    return () => clearInterval(interval);
  }, []);

  const datePattern = language === 'es' ? "EEEE, d 'de' MMMM" : 'EEEE, d MMMM';
  const rawDate = format(currentTime, datePattern, { locale: dateLocales[language] });
  const formattedDate = rawDate.charAt(0).toUpperCase() + rawDate.slice(1);
  const formattedTime = format(currentTime, "HH:mm");

  return (
    <div className="status-bar">
      <div className="status-date">{formattedDate}</div>
      <div className="status-actions">
        <LanguageSelector />
        <div className="status-time">{formattedTime}</div>
      </div>
    </div>
  );
};
